import { hasCapability, type User } from "../base";

export const receipt = {
  create: (user: User) => hasCapability(user, "receipt.create"),
  read: (user: User) => hasCapability(user, "receipt.read"),
};
